import { z } from 'my-zod'

export const corporateFleetStatusEnum = z
  .enum([
    'ActivelyUsed', //when a vehicle is in working condition and actively being used for business purposes
    'Dispositioned', //when a vehicle is no longer owned by Polaris. Vehicle must be removed from Polaris property prior to updating this status. For a full procedure on how to disposition a vehicle please reference ENG-PROC-xxxx
    'NeedsReconditioning', //indicates that a vehicle requires rework prior to being sent to auction or should not be ridden due to open safety holds
    'ReadyForAuction', //when a vehicle has been reworked and all holds have been closed so that the vehicle is ready to go to auction
    'PostedToAuction', //designates that the vehicle is actively posted at auction
    'ReadyToScrap', //designates that the vehicle is no longer needed and is ready to be scrapped. Scrap prep could still be required.
    'HoldUnitForOther', //A vehicle that is being retained for a specific reason and should not be driven or have parts removed without permission of the responsible user. Various reasons for this status include legal investigations, safety, or storage. Please note in the comments the specific reason for holding.
    'ProductCertification', //A certification test vehicle is a vehicle used to officially demonstrate compliance with production regulatory requirements. This status should be selected as soon as the vehicle is selected for product certification.
    'LocationUnknown' //Designates that the unit could not be located upon a quick search. THIS IS NOT A PERMANENT STATUS. If you believe a vehicle is permanently lost or stolen and should be removed from inventory, please fill out the FGBill form and send to finance.
  ])
  .setEnumLabels({
    ActivelyUsed: 'Actively Used',
    Dispositioned: 'Dispositioned',
    NeedsReconditioning: 'Needs Reconditioning',
    ReadyForAuction: 'Ready for Auction',
    PostedToAuction: 'Posted to Auction',
    ReadyToScrap: 'Ready to Scrap',
    HoldUnitForOther: 'Hold Unit for Other',
    ProductCertification: 'Product Certification',
    LocationUnknown: 'Location Unknown'
  })

export type corporateFleetStatusEnum = z.infer<typeof corporateFleetStatusEnum>
